import {
  Checkbox,
  PopupPosition,
  RelativePopupWrapper,
  Tooltip,
  useToggle,
  Text,
  Icons,
} from "@pushpress/shared-components";
import { Task, TaskList } from "../../../../apis/taskApi";
import styles from "./TaskListItem.module.scss";
import { useAnalytics } from "../../../../components/providers/AnalyticsProvider";
import { GetStartedEvent } from "../../events";

type TaskListItemProps = {
  taskList: TaskList;
  task: Task;
  handleUpdateTask: (task: Task) => void;
};

function TaskListItem({ taskList, task, handleUpdateTask }: TaskListItemProps) {
  const [tooltipVisible, tooltipActions] = useToggle(false);
  const { trackEvent } = useAnalytics();

  const { title, description } = task;

  const descriptionTooltip = (description: string) => (
    <div className={styles.taskDescriptionWrapper}>
      <Tooltip text={description} />
    </div>
  );

  return (
    <div className={styles.taskItem} key={task.id}>
      <div className={styles.taskContainer}>
        <Checkbox
          checked={!!task.isComplete}
          onToggle={() => {
            handleUpdateTask(task);
            trackEvent(GetStartedEvent.TaskStatusUpdated, {
              task_list_title: title,
              task_list_id: taskList.taskListId,
              task_uuid: task.uuid,
              task_title: task.title,
              task_complete: !!task.isComplete,
            });
          }}
          className={styles.taskPadding}
        />
        <Text
          className={`${styles.taskDescription} ${styles.taskPadding} ${
            task.isComplete && styles.strikethrough
          }`}
          variant="body-lg"
        >
          {task.title}
        </Text>
        <RelativePopupWrapper
          popupVisible={tooltipVisible}
          popupComponent={descriptionTooltip(description)}
          popupPosition={PopupPosition.Top_Center}
          setPopupVisibility={tooltipActions.set}
          className={styles.taskDescriptionWrapper}
        >
          <Icons.Help
            onMouseEnter={() => {
              tooltipActions.on();
              trackEvent(GetStartedEvent.TaskDescriptionHovered, {
                task_list_title: title,
                task_list_id: taskList.taskListId,
                task_uuid: task.uuid,
                task_title: task.title,
                task_description: task.description,
                task_complete: !!task.isComplete,
              });
            }}
            onMouseLeave={tooltipActions.off}
            style={{ height: 14, width: 14, marginLeft: 10 }}
          />
        </RelativePopupWrapper>
      </div>
      <div className={styles.taskLinkContainer}>
        {task?.links.length > 0 &&
          task.links.map((link) => (
            <div className={styles.taskLinks} key={link.id}>
              <div className={styles.taskLinkDivider} />
              <a
                href={link.url}
                target="_blank"
                rel="noreferrer"
                style={{ paddingLeft: 20 }}
                onClick={() => {
                  trackEvent(GetStartedEvent.TaskLinkClicked, {
                    task_list_title: title,
                    task_list_uuid: taskList.uuid,
                    task_uuid: task.uuid,
                    task_title: task.title,
                    task_link_id: link.id,
                    task_link_title: link.text,
                    task_link_url: link.url,
                    task_complete: !!task.isComplete,
                  });
                }}
              >
                {link.text}
              </a>
            </div>
          ))}
      </div>
    </div>
  );
}

export default TaskListItem;
